export default function({$http, route}) {
  $http.onError(err => {
    console.error('$httpErr:', err.message, route.fullPath)
  })
}